import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const EBSRSelectionsReducer = info => {
  const { selections, accSelections } = info || {};
  const updatedSelections = accSelections;

  const { partA, partB } = selections;

  const selectionsKeysA = Object.keys(partA || {}) || [];
  const selectionsKeysB = Object.keys(partB || {}) || [];

  selectionsKeysA.forEach(categoryKey => {
    if (!updatedSelections.partA) {
      updatedSelections.partA = {};
    }

    if (!updatedSelections.partA[categoryKey]) {
      updatedSelections.partA[categoryKey] = {
        count: 0,
        value: selections.partA[categoryKey].value,
      };
    }

    updatedSelections.partA[categoryKey].count +=
      selections.partA[categoryKey].count;
  });

  selectionsKeysB.forEach(categoryKey => {
    if (!updatedSelections.partB) {
      updatedSelections.partB = {};
    }

    if (!updatedSelections.partB[categoryKey]) {
      updatedSelections.partB[categoryKey] = {
        count: 0,
        value: selections.partB[categoryKey].value,
      };
    }

    updatedSelections.partB[categoryKey].count +=
      selections.partB[categoryKey].count;
  });

  return updatedSelections;
};

export const EBSRSelectionsAggregator = info => {
  const { responses } = info || {};

  return (responses || []).reduce(
    (acc, response) => {
      const { data } = response || {};
      const { value } = data || {};
      const { partA, partB } = value || {};

      let { value: valueA } = partA || {};
      let { value: valueB } = partB || {};

      valueA = valueA || [];
      valueB = valueB || [];

      valueA.forEach(v => {
        const choiceCount = acc.partA[v] ? acc.partA[v].count : 0;

        acc.partA[v] = {
          value: v,
          count: choiceCount + 1,
        };
      });

      valueB.forEach(v => {
        const choiceCount = acc.partB[v] ? acc.partB[v].count : 0;

        acc.partB[v] = {
          value: v,
          count: choiceCount + 1,
        };
      });

      return acc;
    },
    { partA: {}, partB: {} }
  );
};

export default {
  AggregateMap: GlobalAggregateMap(EBSRSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(EBSRSelectionsReducer),
};
